import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import LaundryItemCostListTable from './Componate/LaundryItemCostListTable'

const LaundryItemCostList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Laundry Item Cost List</HeadingOne>
                    <AddItemBtn url="add-laundry-item-cost" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <LaundryItemCostListTable />
            </div>
        </PageBody>
    )
}

export default LaundryItemCostList
